/**
 * 拾荒系统：翻容器能得到什么，以及弄得多脏。
 *
 * 货单按「容器所属」分：每个 prop 的 state.parent 指名一类货单（见 expansion_props.js），
 * 系统层不认具体的器物，只认 parent + level，加新垃圾不用改这里。
 *
 * 每份货单：
 *   items  — [物品id, 权重]，可出多件时由 tries 决定
 *   coin   — 可能摸出几文钱
 *   tries  — 翻一次取几件
 */
import { Repo } from '../data/schema.js';
import { Tags } from './tags.js';
import { getItem, getProp } from '../data/items.js';

/** 各类容器能翻出什么 */
export const LOOT_TABLES = {
  垃圾桶: {
    items: [['plasticBottle', 20], ['tornCardboard', 16], ['usedClothing', 14],
      ['brokenGlass', 10], ['tinCan', 12], ['foam', 8]],
    coin: [0, 3], tries: 2,
  },
  垃圾堆: {
    items: [['plasticBottle', 16], ['tornCardboard', 14], ['usedClothing', 12],
      ['wornOutShoes', 8], ['wovenScraps', 12], ['brokenGlass', 8], ['tinCan', 10]],
    coin: [0, 4], tries: 2,
  },
  泔水桶: {
    items: [['plasticBottle', 10], ['tinCan', 12], ['wornOutShoes', 6],
      ['soapNut', 4], ['herb', 6]],
    coin: [0, 2], tries: 1,
  },
  轮胎堆: {
    items: [['usedTire', 20], ['usedValve', 14], ['steelWireScrap', 12],
      ['wasteEngineOil', 8], ['ironRimPiece', 6], ['tire', 10]],
    coin: [0, 2], tries: 1,
  },
  废铁堆: {
    items: [['scrap_iron', 24], ['bolt', 18], ['steelWireScrap', 14],
      ['ironRimPiece', 10], ['usedValve', 6], ['plate_scrap', 8]],
    coin: [0, 5], tries: 2,
  },
  建筑垃圾: {
    items: [['constructionDebris', 18], ['wood_scrap', 16], ['scrap_wood', 14],
      ['brokenGlass', 8], ['ironRimPiece', 8], ['wovenBag', 6]],
    coin: [0, 6], tries: 2,
  },
  废车: {
    items: [['scrap_iron', 20], ['bolt', 14], ['usedTire', 10], ['usedValve', 8],
      ['usedOilPump', 5], ['oldSteeringWheel', 4], ['usedDiff', 3],
      ['wasteEngineOil', 8], ['engine', 3],
      ['tire', 12], ['frame', 4], ['seat_part', 5], ['battery', 3], ['fuel', 6]],
    coin: [0, 8], tries: 2,
  },
  医疗垃圾桶: {
    items: [['brokenGlass', 14], ['usedClothing', 10], ['plasticBottle', 10], ['herb', 8]],
    coin: [0, 3], tries: 1,
  },
  药箱: {
    items: [['herb', 20], ['plasticBottle', 8], ['soapNut', 6], ['notePaper', 6]],
    coin: [0, 4], tries: 1,
  },
  医药箱: {
    items: [['herb', 18], ['soapNut', 8], ['notePaper', 8], ['brokenGlass', 6]],
    coin: [0, 5], tries: 2,
  },
  工具箱: {
    items: [['bolt', 20], ['scrap_iron', 14], ['steelWireScrap', 10], ['wood_scrap', 6]],
    coin: [0, 6], tries: 2,
  },
  工具棚: {
    items: [['wood_scrap', 18], ['scrap_iron', 14], ['bolt', 12], ['burlapSack', 8],
      ['steelWireScrap', 8], ['petCage', 4], ['seat_part', 3], ['battery', 2]],
    coin: [0, 10], tries: 3,
  },
  板条箱: {
    items: [['burlapSack', 16], ['usedClothing', 14], ['wovenScraps', 12],
      ['tinCan', 10], ['herb', 8], ['egg', 6]],
    coin: [0, 12], tries: 3,
  },
  螺栓箱: {
    items: [['bolt', 22], ['scrap_iron', 16], ['usedValve', 8], ['notePaper', 6]],
    coin: [0, 8], tries: 2,
  },
  钉死的箱子: {
    items: [['wood_scrap', 18], ['scrap_wood', 14], ['usedClothing', 10], ['wovenBag', 6]],
    coin: [0, 7], tries: 2,
  },
  封条纸箱: {
    items: [['notePaper', 18], ['usedClothing', 12], ['tinCan', 10],
      ['villainsEvidence', 3], ['falsifiedLedger', 2]],
    coin: [0, 15], tries: 2,
  },
  密封罐: {
    items: [['wasteEngineOil', 16], ['plasticBottle', 10], ['brokenGlass', 8],
      ['smuggledSalt', 5], ['unstampedLiquor', 4], ['fuel', 5]],
    coin: [0, 12], tries: 2,
  },
  油桶: {
    items: [['wasteEngineOil', 22], ['plasticBottle', 10], ['scrap_iron', 8], ['fuel', 8]],
    coin: [0, 8], tries: 1,
  },
  肥料桶: {
    items: [['brokenGlass', 12], ['plasticBottle', 10], ['notePaper', 8], ['seed', 10]],
    coin: [0, 6], tries: 1,
  },
  稀料桶: {
    items: [['plasticBottle', 16], ['brokenGlass', 10], ['scrap_iron', 8]],
    coin: [0, 5], tries: 1,
  },
  漆桶: {
    items: [['scrap_iron', 16], ['tinCan', 14], ['plasticBottle', 10], ['wood_scrap', 6]],
    coin: [0, 6], tries: 1,
  },
  化学桶: {
    items: [['brokenGlass', 16], ['plasticBottle', 12], ['scrap_iron', 10],
      ['smuggledSalt', 6], ['unstampedLiquor', 5]],
    coin: [0, 20], tries: 1,
  },
  灰堆: {
    items: [['scrap_iron', 14], ['brokenGlass', 10], ['bolt', 8], ['plate_scrap', 6]],
    coin: [0, 4], tries: 1,
  },
  展示柜: {
    items: [['notePaper', 14], ['falsifiedLedger', 6], ['soapNut', 6]],
    coin: [0, 10], tries: 1,
  },
  浸水发霉的家居地毯: {
    items: [['usedClothing', 20], ['wornOutShoes', 10], ['tornCardboard', 10],
      ['brokenGlass', 6], ['tinCan', 8]],
    coin: [0, 5], tries: 2,
  },
  破棉被: {
    items: [['usedClothing', 18], ['wovenScraps', 12], ['tornCardboard', 8]],
    coin: [0, 3], tries: 1,
  },
};

/** 没有专门货单的，给个最素的街边兜底 */
const FALLBACK = {
  items: [['plasticBottle', 12], ['tornCardboard', 10], ['usedClothing', 8], ['brokenGlass', 6]],
  coin: [0, 2], tries: 1,
};

function pickWeighted(list) {
  const pool = list.filter(([, w]) => w > 0);
  if (!pool.length) return null;
  const total = pool.reduce((s, [, w]) => s + w, 0);
  let r = Math.random() * total;
  for (const [id, w] of pool) { r -= w; if (r <= 0) return id; }
  return pool[pool.length - 1][0];
}

/**
 * 抽一次货。
 * @param {string} parent 货单名
 * @param {number} level  器物等级 1~5，越高多给一件
 */
export function rollLoot(parent, level = 1) {
  const table = LOOT_TABLES[parent] || FALLBACK;
  const tries = table.tries + (level >= 3 ? 1 : 0) + (level >= 5 ? 1 : 0);
  const got = new Map();
  for (let i = 0; i < tries; i += 1) {
    const id = pickWeighted(table.items);
    if (id) got.set(id, (got.get(id) || 0) + 1);
  }
  const [cMin, cMax] = table.coin;
  let coin = 0;
  if (cMax > 0 && Math.random() < 0.35) coin = cMin + Math.floor(Math.random() * (cMax - cMin + 1));
  return { items: [...got].map(([id, n]) => ({ id, n })), coin };
}

/**
 * 真翻一个容器：出货、记账、把一身灰加到身上。
 * @returns {{ok:boolean, reason?:string, got?:Array, coin?:number}}
 */
export function scavenge(db, prop) {
  const w = Repo.getWorld(db);
  const st = prop.state || {};
  if (st.day === w.day) return { ok: false, reason: '这里今天翻过了，明日再来。' };
  const p = Repo.getPlayer(db);
  if ((p.energy || 0) < 5) return { ok: false, reason: '累得手都抬不起来，明天再翻吧。' };

  const level = Math.max(1, Math.min(5, Number(st.level) || 1));
  const { items, coin } = rollLoot(st.parent || prop.type, level);
  for (const it of items) Repo.addItem(db, it.id, it.n);
  if (coin > 0) Repo.addItem(db, 'coin', coin);

  // 脏与味：容器的脏度决定加多少，穿什么衣裳能挡多少在 avatar 里另算
  const def = prop.def || getProp(prop.type) || {};
  const dState = (def.state && typeof def.state === 'object') ? def.state : {};
  const dAdd = Number(dState.dirty != null ? dState.dirty : 2);
  const sAdd = Number(dState.stink != null ? dState.stink : 1);
  if (dAdd) Tags.gain(db, 'dirty', dAdd, `scavenge:${prop.type}`, 40);
  if (sAdd) Tags.gain(db, 'stink', sAdd, `scavenge:${prop.type}`, 40);

  Repo.savePlayer(db, { energy: Math.max(0, (p.energy || 0) - 4), mood: Math.max(0, (p.mood || 0) - 1) });
  prop.state = { ...st, day: w.day };
  db.table('props').update(prop.id, { state: prop.state });

  const text = items.length
    ? items.map((it) => `${getItem(it.id).name}x${it.n}`).join('、')
    : '只有一把灰';
  return { ok: true, got: items, coin, text: `翻到${text}${coin ? `、${coin}文` : ''}。` };
}

/** 今天是第几天：翻找记录按它记 */
export function todayKey(db) {
  const w = Repo.getWorld(db);
  return `${w.day}`;
}

export const Loot = {
  LOOT_TABLES,
  rollLoot,
  scavenge,
  parents: () => Object.keys(LOOT_TABLES),
};
